import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import RequestCard from "../components/RequestCard";
import RouteMap from "../components/RouteMap";

export default function Matches() {
  const { user } = useAuth();
  const [openRequests, setOpenRequests] = useState([]);
  const [selected, setSelected] = useState(null);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/requests", { params: { scope: "open" } }).then((r) => setOpenRequests(r.data));
  }, []);

  useEffect(() => {
    if (!selected) return;
    setLoading(true);
    api.get(`/requests/${selected.request_id}/matches`)
      .then((r) => setMatches(r.data))
      .finally(() => setLoading(false));
  }, [selected]);

  const routes = selected
    ? [
        { pickup: selected.pickup, dropoff: selected.dropoff, color: "#E8A020" },
        ...matches.slice(0, 4).map((m) => ({ pickup: m.pickup, dropoff: m.dropoff, color: "#161712" })),
      ]
    : [];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="matches-page">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="text-[11px] uppercase tracking-widest font-bold text-orange-600">Moteur de matching</div>
          <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-slate-900 tracking-tight">Matching aller/retour</h1>
          <p className="text-sm text-slate-600 mt-1">Choisissez une mission pour découvrir les missions complémentaires sur le même axe ou en retour.</p>

          <div className="mt-6 grid lg:grid-cols-5 gap-6">
            <div className="lg:col-span-2 space-y-3 max-h-[70vh] overflow-auto no-scrollbar pr-1">
              <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">Missions ouvertes</div>
              {openRequests.map((r) => (
                <button key={r.request_id} onClick={() => setSelected(r)} className={`w-full text-left ${selected?.request_id === r.request_id ? "ring-2 ring-orange-600 rounded-md" : ""}`} data-testid={`select-${r.request_id}`}>
                  <RequestCard req={r} compact />
                </button>
              ))}
              {openRequests.length === 0 && <div className="text-sm text-slate-500">Aucune mission ouverte actuellement.</div>}
            </div>

            <div className="lg:col-span-3">
              {!selected ? (
                <div className="bg-white border border-slate-200 rounded-md p-10 text-center text-slate-500">
                  Sélectionnez une mission pour voir les matches.
                </div>
              ) : (
                <div className="space-y-4">
                  <div className="bg-white border border-slate-200 rounded-md p-4">
                    <RouteMap routes={routes} height={360} />
                    <div className="mt-3 flex items-center gap-3 text-xs text-slate-600">
                      <span className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-orange-600" /> Mission sélectionnée</span>
                      <span className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-slate-900" /> Match A/R</span>
                    </div>
                  </div>

                  <div className="text-[10px] uppercase tracking-widest text-orange-600 font-bold">Missions matchées</div>
                  {loading ? (
                    <div className="text-sm text-slate-500">Calcul en cours…</div>
                  ) : matches.length === 0 ? (
                    <div className="bg-white border border-dashed border-slate-300 rounded-md p-8 text-center text-slate-500 text-sm">
                      Pas de match pour le moment. Réessayez plus tard quand plus de missions seront publiées.
                    </div>
                  ) : (
                    <div className="grid sm:grid-cols-2 gap-3" data-testid="matches-list">
                      {matches.map((m) => (
                        <RequestCard key={m.request_id} req={{ ...m, status: "open", distance_km: 0 }} score={m.best_score} matchType={m.match_type} compact />
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
